import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./index.css";

const rootEl = document.getElementById("mm-map");
if (rootEl) {
  const posts = JSON.parse(document.getElementById("mm-map-post-data").innerHTML);

  ReactDOM.render(<App posts={posts} />, rootEl);
}
